import { render, staticRenderFns } from "./NavButtonActive.vue?vue&type=template&id=713f2186&"
import script from "./NavButtonActive.vue?vue&type=script&lang=js&"
export * from "./NavButtonActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports